module.exports = __webpack_public_path__ + "img/scopus.753f9655.png";